import { DocumentsSectionController } from './documents-section.controller'

function documentsSectionDirective () {
  return {
    restrict: 'E',
    scope: {
      task: '<'
    },
    templateUrl: '/workflow/directives/documents-section/documents-section-directive.html?$$REVISION$$',
    controller: DocumentsSectionController
  }
}

export { documentsSectionDirective }
